import { ManagedUser } from "./managed-user.model";

export class CreateUserWithCompanyAccess {
    constructor(public userRole: ManagedUser, public usersForAccess: ManagedUser[]) {
        this.userRole = userRole;
        this.usersForAccess = usersForAccess;
    }
}
